import { faExclamationCircle } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Flex, Text } from '@modusign/design-system';
import { Controller, useFormContext } from 'react-hook-form-v7';

import SingleDatePicker from '@app/components/DatePicker/SingleDatePicker';
import { BasicInformationFormState } from '@app/features/externalDocument/components/BasicInformationEditor';
import { EXTERNAL_DOCUMENT_DEFAULT_FROM_YEAR } from '@app/features/externalDocument/constants';

export default function DateOfCompletionInput() {
  const { setValue, watch } = useFormContext<BasicInformationFormState>();
  const documentPeriod = watch('documentPeriod');

  return (
    <Controller
      name="dateOfCompletion"
      render={({ field: { value, onChange } }) => (
        <SingleDatePicker
          captionLayout="dropdown-buttons"
          defaultMonth={value ? new Date(value) : undefined}
          field={{
            placeholder: 'YYYY.MM.DD',
            style: {
              width: '100%',
              height: '100%',
              flex: 'auto',
              padding: '8px',
            },
            onClearDate: () => {
              onChange(null);
              setValue('renewalRadio', '0');
            },
          }}
          footer={
            <Box mx="22px" pb={3}>
              <Flex
                alignItems="center"
                as="section"
                bg="notificationBackgroundPrimaryBase"
                border="1px solid"
                borderColor="boxBorderPrimaryBase"
                borderRadius="3px"
                color="textNeutralSlightlyLight"
                px={5}
                py={4}
              >
                <Text color="iconPrimaryDark" fontSize="12px" mr={2}>
                  <FontAwesomeIcon icon={faExclamationCircle} />
                </Text>
                <Text color="textNeutralSlightlyLight" fontSize="sm">
                  계약 종료일 이후 날짜 선택 불가
                </Text>
              </Flex>
            </Box>
          }
          fromYear={EXTERNAL_DOCUMENT_DEFAULT_FROM_YEAR}
          toDate={documentPeriod?.to ? new Date(documentPeriod.to) : new Date(2099, 11, 31)}
          value={value ? new Date(value) : undefined}
          onSelect={(value) => {
            onChange(value?.toISOString() || null);
            if (!value) {
              setValue('renewalRadio', '0');
            }
          }}
        />
      )}
    />
  );
}
